import React from 'react';
import { Button, Link } from '@common/components';
import { buildDialogUrl } from '@common/services';
import { DisputeAvailableActionType } from '@pay-bill/graphql';
import { capitalize } from 'lodash';

export const DisputeViewDrawerButton = ({
  disputeCode,
  action,
  label,
}: {
  disputeCode: string;
  action: DisputeAvailableActionType;
  label?: string;
}) => {
  const disputeViewDrawerUrl = buildDialogUrl('dispute-view-drawer', {
    props: { action, disputeCode },
    overlap: false,
  });

  return (
    <Link to={disputeViewDrawerUrl}>
      <Button
        className="dispute-view-button"
        kind={['approve', 'accept'].includes(action) ? 'primary' : 'secondary'}
        danger={action === 'reject'}
      >
        {label || capitalize(action)}
      </Button>
    </Link>
  );
};
